export const filterConfigText = (value) => {
    if (Object.keys(configTranslations).filter(item => item == value).length == 0) {
        return;
    }
    return `${headerTypes[configTranslations[value].type]} ${configTranslations[value].isButton ? 'Botão' : ''} 
    ${configTranslations[value].name}`
}

const configTranslations =
{
    projetoseSolucoes: {
        name: 'Projetos e Soluções',
        type: 'menu'
    },
    unidadesRegionais:
    {
        name: 'Unidades Regionais',
        type: 'menu'
    },
    temas:
    {
        name: 'Temas',
        type: 'menu'
    },
    eixos:
    {
        name: 'Eixos',
        type: 'menu'
    },
    pacotes: {
        name: 'Pacotes',
        type: 'menu'
    },
    perguntas: {
        name: 'Perguntas',
        type: 'menu'
    },
    medalhas: {
        name: 'Medalhas',
        type: 'menu'
    },
    usuarios: {
        name: 'Usuarios',
        type: 'menu'
    },
    analisarRelatorios: {
        name: 'Analisar Relatorios',
        type: 'menu'
    },
    encontros: {
        name: 'Encontros',
        type: 'menu'
    },
    dashboardAdministrativo: {
        name: 'Dashboard Administrativo',
        type: 'menu'
    },
    processosPagamento: {
        name: 'Processos de Pagamento',
        type: 'menu'
    },
    meusProcessosPagamentos: {
        name: 'Meus Processos de Pagamentos',
        type: 'menu'
    },

    analisarRelatoriosAdministrativos: {
        name: 'Analisar Relatorios Administrativos',
        type: 'menu'
    },
    eventos: {
        name: 'Eventos',
        type: 'menu'
    },
    relatorioGlobal: {
        name: 'Relatório Global',
        type: 'dashboard',
        isButton: true
    },
    cadastroEmLote: {
        name: 'Cadastro em Lote',
        type: 'cidade',
        isButton: true
    },
    relatorioMensal: {
        name: 'Relatório Mensal',
        type: 'cidade',
        isButton: true
    },
    acompanhamentos: {
        name: 'Acompanhamentos',
        type: 'cidade'
    },
    novoAcompanhamento: {
        name: 'Novo Acompanhamento',
        type: 'cidade',
        isButton: true
    },
    relatorios: {
        name: 'Relatórios',
        type: 'cidade'
    },
    novoRelatorio: {
        name: 'Novo Relatório',
        type: 'relatorio',
        isButton: true
    },
    novoRelatorioAdministrativo: {
        name: 'Novo Relatório Admin.',
        type: 'relatorioAdmin',
        isButton: true
    },
    calendario: {
        name: 'Calendário',
        type: 'cidade'
    },
    novoEvento: {
        name: 'Novo Evento',
        type: 'calendario',
        isButton: true
    },
    evidencias: {
        name: 'Evidências',
        type: 'cidade'
    },
    enviarRespondidas: {
        name: 'Enviar Respondidas',
        type: 'evidencia',
        isButton: true
    },
    enviarEvidenciadas: {
        name: 'Enviar Evidenciadas',
        type: 'evidencia',
        isButton: true
    },
    enviarAprovadas: {
        name: 'Enviar Aprovadas',
        type: 'evidencia',
        isButton: true
    },
    enviarRejeitadas: {
        name: 'Enviar Rejeitadas',
        type: 'evidencia',
        isButton: true
    },
    visualizarEvidenciadas: {
        name: 'Visualizar Evidenciadas',
        type: 'evidencia',
        isButton: true
    },
    visualizarAprovadas: {
        name: 'Visualizar Aprovadas',
        type: 'evidencia',
        isButton: true
    },
    visualizarRejeitadas: {
        name: 'Visualizar Rejeitadas',
        type: 'evidencia',
        isButton: true,
        isButton: true
    },
    analisarEvidenciadas: {
        name: 'Analisar Evidenciadas',
        type: 'evidencia',
        isButton: true
    },
    analisarAprovadas: {
        name: 'Analisar	Aprovadas',
        type: 'evidencia',
        isButton: true
    },
    analisarRejeitadas: {
        name: 'Analisar Rejeitadas',
        type: 'evidencia',
        isButton: true
    },
    grupos: {
        name: 'Grupos',
        type: 'cidade'
    },
    novoGrupo: {
        name: 'Novo Grupo',
        type: 'grupo',
        isButton: true
    },
    andamento: {
        name: 'Andamento',
        type: 'cidade'
    },
    termoReferencia: {
        name: 'Termo de Referência',
        type: 'cidade'
    },
    relatorioAdministrativo: {
        name: 'Relatório Administrativo',
        type: 'cidade'
    },
    sala: {
        name: 'Sala',
        type: 'cidade'
    },
    editarMunicipio: {
        name: 'Editar Município',
        type: 'cidade',
        isButton: true
    },
    realizarDiagnostico: {
        name: 'Realizar Diagnóstico',
        type: 'cidade'
    },
    agenteTerritorial: {
        name: 'Agente Territorial',
        type: 'cidade',
        isButton: true
    },
    finalizarAcompanhamento: {
        name: 'Finalizar Acompanhamento',
        type: 'cidade',
        isButton: true
    },
    configuracao: {
        name: 'Configuração',
        type: 'menu'
    },
    grupo: {
        name: 'Grupos',
        type: 'menu'
    }

}

const headerTypes = {
    menu: 'Menu -->',
    cidade: 'Municipio --> Cidade -->',
    dashboard: 'Menu --> Dashboard Admin. -->',
    evidencia: 'Municipio --> Cidade --> Evidência -->',
    calendario: 'Municipio --> Cidade --> Calendário -->',
    relatorio: 'Municipio -- > Cidade --> Relatório -->',
    grupo: 'Municipio -- > Cidade-- > Grupos -->',
    relatorioAdmin: 'Municipio -- > Cidade --> Relatório Admin.-->'

}

export const initialConfig = {
    projetoseSolucoes: false,
    unidadesRegionais: false,
    temas: false,
    eixos: false,
    pacotes: false,
    perguntas: false,
    medalhas: false,
    usuarios: false,
    analisarRelatorios: false,
    encontros: false,
    dashboardAdministrativo: false,
    processosPagamento: false,
    meusProcessosPagamentos: false,
    analisarRelatoriosAdministrativos: false,
    eventos: false,
    relatorioGlobal: false,
    cadastroEmLote: false,
    relatorioMensal: false,
    acompanhamentos: false,
    novoAcompanhamento: false,
    relatorios: false,
    novoRelatorio: false,
    novoRelatorioAdministrativo: false,
    calendario: false,
    novoEvento: false,
    evidencias: false,
    enviarRespondidas: false,
    enviarEvidenciadas: false,
    enviarAprovadas: false,
    enviarRejeitadas: false,
    visualizarEvidenciadas: false,
    visualizarAprovadas: false,
    visualizarRejeitadas: false,
    analisarEvidenciadas: false,
    analisarAprovadas: false,
    analisarRejeitadas: false,
    grupos: false,
    novoGrupo: false,
    andamento: false,
    termoReferencia: false,
    relatorioAdministrativo: false,
    sala: false,
    editarMunicipio: false,
    realizarDiagnostico: false,
    agenteTerritorial: false,
    finalizarAcompanhamento: false,
    configuracao: false,
    grupo: false

}